import { ColumnSetupType } from "../../../../../../../../../../../../../../storybook/data-grid/utils/types/types";
import { Ec2 } from "../../../../../../../../../../../../../../services/cloudchipr.api";
import { ResourceMetricsHeaderCell } from "../../../../../cells/metrics-cells/components/ResourceMetricsHeaderCell";

export const eksEc2Columns: ColumnSetupType<Ec2>[] = [
  {
    accessorKey: "name",
    header: "Name",
    type: "identifier",
    size: 210,
    meta: { sticky: "left", hideFromSettings: true },
  },
  {
    accessorKey: "instance_id",
    header: "Instance-id",
    type: "identifierWithRecommendationLink",
  },
  {
    accessorKey: "price_per_month",
    header: "Monthly Price",
    type: "money",
    headerTooltip:
      "Monthly prices are calculated based on the on-demand list price of each resource.",
  },
  {
    accessorKey: "resource_state",
    header: "State",
    type: "resourceState",
  },
  {
    id: "cpu_max",
    size: 220,
    minSize: 165,
    maxSize: 300,
    enableSorting: false,
    meta: { cellStyles: { p: 0 }, headerTitle: "CPU Max" },
    accessorKey: "inline_metrics",
    type: "computeMetricsChart",
    header: ResourceMetricsHeaderCell,
  },
  {
    size: 250,
    minSize: 250,
    maxSize: 350,
    enableSorting: false,
    meta: { cellStyles: { p: 0 }, headerTitle: "Memory Utilization Max" },
    accessorKey: "inline_metrics",
    id: "memory_max",
    type: "memoryUsedMetricsChart",
    header: ResourceMetricsHeaderCell,
  },
  {
    size: 250,
    minSize: 250,
    maxSize: 350,
    enableSorting: false,
    meta: { cellStyles: { p: 0 }, headerTitle: "Memory Available Min" },
    accessorKey: "inline_metrics",
    id: "unused_memory",
    type: "memoryAvailableMetricsChart",
    header: ResourceMetricsHeaderCell,
  },
  {
    accessorKey: "all_time_spent",
    header: "Total Spend",
    type: "money",
  },
  {
    accessorKey: "created_at",
    header: "Launch time",
    type: "date",
  },
  { accessorKey: "type", header: "Instance Type" },
  {
    accessorKey: "cpu_value",
    header: "CPU Max",
    headerTooltip: "The maximum usage of CPU for the last 7 days.",
    type: "cpuStatistic",
  },
  { accessorKey: "tags", header: "Tags", type: "tag", enableSorting: false },
];
